import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaTools, FaProjectDiagram, FaEnvelopeOpen } from 'react-icons/fa';
import HeaderDesktop from '../Desktop/HeaderDesktop';
import HeaderMobile from '../Mobile/HeaderMobile';

const Header = ({ siteData, isRTL, t }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const location = useLocation();
  const navigate = useNavigate();
  const mobileMenuRef = useRef(null);

  const { site_info, navigation, contact_info, social_media } = siteData;

  const scrollConfig = {
    smooth: true,
    duration: 800,
    spy: true,
    offset: -100,
    activeClass: 'active1',
    ignoreCancelEvents: false,
    spyThrottle: 500
  };

  const handleSetActive = (to) => {
    setActiveSection(to)
  }

  const closeMenu = () => setIsOpen(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      scrollToTop();
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById("root");
        if (element) {
          const yOffset = -100;
          const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: yPosition, behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleNavigation = (item) => {
    closeMenu();

    if (item.to && location.pathname !== '/') {
      navigate(item.href);
      setTimeout(() => {
        const element = document.getElementById(item.to);
        if (element) {
          const yOffset = -100;
          const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: yPosition, behavior: 'smooth' });
          setActiveSection(item.to);
        }
      }, 100);
    } else if (item.to && location.pathname === '/') {
      const element = document.getElementById(item.to);
      if (element) {
        const yOffset = -100;
        const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: yPosition, behavior: 'smooth' });
        setActiveSection(item.to);
      }
    } else if (item.href) {
      navigate(item.href);
      setActiveSection(item.href);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const LinkContent = ({ item }) => (
    <>
      {item.icon && (
        <span className="nav-icon">
          {item.icon === 'home' && <FaHome />}
          {item.icon === 'about' && <FaInfoCircle />}
          {item.icon === 'services' && <FaTools />}
          {item.icon === 'projects' && <FaProjectDiagram />}
          {item.icon === 'contact' && <FaEnvelopeOpen />}
        </span>
      )}
      <span>{item.title}</span>
    </>
  );

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    if (location.state?.scrollTo) {
      const elementId = location.state.scrollTo === 'root' ? 'root' : location.state.scrollTo;
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          const yOffset = -100;
          const yPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: yPosition, behavior: 'smooth' });
        }
        navigate(location.pathname, { replace: true, state: {} });
      }, 500);
    } else {
      setActiveSection(location.pathname);
    }
  }, [location, navigate]);

  return (
    <header className={`header-transparent ${isScrolled ? 'scrolled' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <HeaderDesktop
        isScrolled={isScrolled}
        site_info={site_info}
        navigation={navigation}
        contact_info={contact_info}
        social_media={social_media}
        handleLogoClick={handleLogoClick}
        handleNavigation={handleNavigation}
        activeSection={activeSection}
        isRTL={isRTL}
        t={t}
        scrollConfig={scrollConfig}
        handleSetActive={handleSetActive}
        LinkContent={LinkContent}
      />
      <HeaderMobile
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isScrolled={isScrolled}
        site_info={site_info}
        navigation={navigation}
        contact_info={contact_info}
        social_media={social_media}
        handleLogoClick={handleLogoClick}
        handleNavigation={handleNavigation}
        activeSection={activeSection}
        isRTL={isRTL}
        t={t}
        scrollConfig={scrollConfig}
        handleSetActive={handleSetActive}
        LinkContent={LinkContent}
      />
    </header>
  );
};

export default Header;